import useGetUserExperimentSegment from "@/features/useGetUserExperimentSegment";
import useGetUserProperties from "@/users/v3/useGetUserProperties";

const useShowProductsSection = () => {
  const {
    isStudent,
    activeSSLicense,
    activeELALicense,
    activeScienceLicense,
    activeEssentialsLicense,
    canViewSearch,
  } = useGetUserProperties();
  const [showLockIconsExperiment] =
    useGetUserExperimentSegment("show_lock_icons");
  const showLicenseItemWithLock = showLockIconsExperiment === "on";

  if (!canViewSearch) return false;

  return (
    activeELALicense ||
    activeSSLicense ||
    activeScienceLicense ||
    activeEssentialsLicense ||
    (!isStudent && showLicenseItemWithLock)
  );
};

export default useShowProductsSection;
